














import {
  Component,
  Prop,
  Vue,
} from 'vue-property-decorator';

@Component
export default class CancelButton extends Vue {
  @Prop() private classes!: string;
  @Prop({default: false}) private small!: boolean;
  @Prop({default: false}) private isDisabled!: boolean;
  @Prop({default: false}) private block!: boolean;
}
